import React from "react";
import { BookOpen, Headphones, RefreshCcw, Video } from "lucide-react";

const PRESETS = {
  articles: {
    title: (topic) => `No articles yet for ${topic}`,
    description:
      "Verified providers have not published guides for this topic yet. Check back soon or explore the overview.",
    icons: [BookOpen],
  },
  media: {
    title: (topic) => `No media available for ${topic}`,
    description:
      "There are no videos or podcasts for this topic yet. Providers will add watch and listen content here when it is ready.",
    icons: [Video, Headphones],
  },
  article: {
    title: () => "This guide is not available",
    description:
      "We could not load this article right now. It may have been moved or is not published yet for this topic.",
    icons: [BookOpen],
  },
};

export default function TopicLibraryEmptyState({
  kind = "articles",
  topicLabel = "this topic",
  color = "#c9a000",
  onRetry,
  showRetry = false,
  className = "",
}) {
  const preset = PRESETS[kind] || PRESETS.articles;
  const icons = preset.icons;

  return (
    <div
      className={`flex min-h-[20rem] flex-col items-center justify-center rounded-[2rem] border border-dashed border-black/12 bg-white px-8 py-16 text-center ${className}`}
      role="status"
    >
      <div className="mb-5 flex items-center justify-center gap-3">
        {icons.map((Icon, index) => (
          <div
            key={index}
            className="flex h-12 w-12 items-center justify-center rounded-xl shadow-sm ring-1 ring-black/[0.04]"
            style={{ background: `${color}14`, color }}
          >
            <Icon size={22} strokeWidth={2} aria-hidden />
          </div>
        ))}
      </div>
      <h3 className="text-lg font-black text-gray-900 sm:text-xl">{preset.title(topicLabel)}</h3>
      <p className="mt-2 max-w-md text-sm leading-relaxed text-gray-500">{preset.description}</p>
      {showRetry && onRetry ? (
        <button
          type="button"
          onClick={onRetry}
          className="mt-6 inline-flex items-center gap-2 rounded-xl border border-black/10 bg-[#f7f4ec] px-5 py-2.5 text-sm font-bold text-gray-800 transition hover:bg-[#efe9dc]"
        >
          <RefreshCcw size={14} aria-hidden />
          Try again
        </button>
      ) : null}
    </div>
  );
}
